import React from 'react';
import AbstractSection from "../AbstractSection";
import { withFormControl } from "puzzle";
import { config } from "./TemplateSection.config";
import classNames from "classnames";


class TemplateSection extends AbstractSection {

  static defaultProps = {
    moduleName: 'AbstractSection'
  };

  /**
   * @inheritDoc
   */
  addDueDateField = () => {
    return (<></>);
  };

  /**
   * @inheritDoc
   */
  addDueDate = () => {
    return null;
  };

  /**
   * @inheritDoc
   */
  disableUpload = () => {
    return true;
  };

  /**
   * @inheritDoc
   */
  getSectionButtonsStyles = () => {
    const {
      name,
      targetLanguage,
      workflowId,
    } = this.props.form.getFields();

    const clearBatchDetailsClass = classNames('tp-clear-batch-details', {
      'k-state-disabled': !(name.value || workflowId.value || targetLanguage.value.length)
    });
    const copyBatchDetailsClass = classNames('tp-copy-batch-details', {
      'k-state-disabled': !(name.value && workflowId.value && targetLanguage.value.length)
    });
    return {
      clearBatchDetailsClass,
      copyBatchDetailsClass
    }
  };

}

export default withFormControl(config)(TemplateSection);
